import React from 'react';
import { CommerceAddress } from '@css-xp/graphtypes';

// Stolen from Commerce: https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/commerce/commerce-billing-details/src/ui/billing-address-details/index.tsx

/**
 * Component to represent an address in a single line (tables, options)
 */
const BillingAddressDetailsLine = ({
  address,
  noAddressLabel = 'no address provided',
  shouldDisplayName = true,
}: {
  address?: CommerceAddress | null;
  noAddressLabel?: string;
  shouldDisplayName?: boolean;
}) => {
  if (!address) {
    return (
      <div>
        <em>{noAddressLabel}</em>
      </div>
    );
  }
  const { name, addressLine1, addressLine2, country, postcode, state, city } = address;
  return (
    <div
      vocab="https://schema.org/"
      property="address"
      typeof="PostalAddress"
      className="select-commerce-address-line"
      data-testid="billing-address-details-line"
    >
      {!!name && shouldDisplayName && <span>{name}</span>}
      {(!!addressLine1 || !!addressLine2) && (
        <span property="streetAddress">
          {!!addressLine1 && addressLine1}
          {!!addressLine2 && `, ${addressLine2}`}
        </span>
      )}
      {!!postcode && <span property="postalCode">{postcode}</span>}
      {!!city && <span property="addressLocality">{city}</span>}
      {!!state && <span property="addressRegion">{state}</span>}
      {!!country && <span property="countryName">{country}</span>}
    </div>
  );
};

export default BillingAddressDetailsLine;
